import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { InventoryItem } from "./InventoryLayout";

type Props = {
  inventoryItems: InventoryItem[];
  loading: boolean;
};

const InventoryTable: React.FC<Props> = ({ inventoryItems, loading }) => {
  const SrNo = (_rowData: InventoryItem, options: any) => (
    <div className="flex align-items-center gap-2">
      <span>{options.rowIndex + 1}</span>
    </div>
  );

  const CreatedDateTemplate = (rowData: InventoryItem) => (
    <div className="flex align-items-center gap-2">
      <span>
        {new Date(rowData.uploadedDate).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    </div>
  );

  const ValidUptoDateTemplate = (rowData: InventoryItem) => (
    <div className="flex align-items-center gap-2">
      <span>
        {new Date(rowData.expiryDate).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    </div>
  );

  const descriptionTemplate = (rowData: InventoryItem) => {
    const text = rowData.description || "";
    return (
      <span
        className="desc-tooltip"
        data-pr-tooltip={text.length > 25 ? text : ""}
        data-pr-position="top"
      >
        {text.length > 25 ? text.substring(0, 25) + "..." : text}
      </span>
    );
  };

  const actionBodyTemplate = (rowData: InventoryItem) => {
    if (!rowData.fileUrl) return null;
    return (
      <Button
        className="table-button custome-icon"
        icon="pi pi-download"
        tooltip="Download"
        onClick={() => window.open(rowData.fileUrl as string, "_blank")}
      />
    );
  };

  return (
    <div className="table-section">
      <Tooltip target=".desc-tooltip" />

      <DataTable
        paginator
        rows={15}
        value={inventoryItems}
        dataKey="inventoryId"
        scrollHeight="600px"
        loading={loading}
        emptyMessage="No inventory documents found."
      >
        <Column
          field="srNo"
          header="Sr.No."
          style={{ minWidth: "3rem" }}
          body={SrNo}
        />
        <Column
          field="inventoryName"
          header="Inventory Name"
          style={{ minWidth: "12rem" }}
          sortable
        />
        <Column
          field="description"
          header="Description"
          style={{ minWidth: "10rem" }}
          body={descriptionTemplate}
          sortable
        />
        <Column
          field="uploadedDate"
          header="Created Date"
          body={CreatedDateTemplate}
          style={{ minWidth: "10rem" }}
          sortable
        />
        <Column
          field="expiryDate"
          header="Valid Upto Date"
          body={ValidUptoDateTemplate}
          style={{ minWidth: "10rem" }}
          sortable
        />
        <Column
          field="Action"
          header="Action"
          style={{ minWidth: "6rem" }}
          body={actionBodyTemplate}
        />
      </DataTable>
    </div>
  );
};

export default InventoryTable;
